import React, { useState, useEffect, Fragment } from 'react';

import { Grid, TextField, Button, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import useStyles from './IMInventoryEntry.styles';
import useProductsIM from 'hooks/useProductsIM';
import productImage from 'assets/img/productDefault.png';
import Skeleton from '@material-ui/lab/Skeleton';
import { ENTRADA } from 'constants/constBd';
import useInventoryEntryIM from 'hooks/useMovementsIM';
import NumberFormat from 'react-number-format';
import { FormEntry } from 'interfaces/imInventoryMovements.interface';
import { IGaleryImages, IProducts } from 'interfaces/imProducts.interface';
interface Props {
  productId: number;
  parentId: number;
  handleCloseModal(): void;
  getAllProducts(): void;
}

export default function IMInventoryEntryForm({ productId, getAllProducts, handleCloseModal, parentId }: Props) {
  const { getProductById } = useProductsIM();
  const { showNotistack } = useCustomSnackbar();
  const { createMovement } = useInventoryEntryIM();

  const { handleSubmit, register, errors } = useForm<FormEntry>();
  const [productDetail, setProductDetail] = useState({
    sku: '',
    name: ''
  });

  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [galeryImagesProduct, setGaleryImagesProduct] = useState<IGaleryImages[]>([]);
  const getProduct = () => {
    setIsLoading(true);
    getProductById(String(productId))
      .then((resultProduct: IProducts) => {
        setGaleryImagesProduct(resultProduct.galeryImages);
        setProductDetail({ name: resultProduct.name, sku: resultProduct.sku });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getProduct();
  }, []);
  const onSubmit = (data: FormEntry) => {
    data.unitCost = data.unitCost.replace(/[^0-9,-]+/g, '');

    const document = {
      remission: data.remission,
      invoice: data.invoice,
      purchaseOrder: data.purchaseOrder,
      order: '',
      guide: '',
      observations: data.observations,
      documentTypeId: ENTRADA
    };

    const dataToSed = [
      {
        document: document,
        products: [{ parentId: parentId, productId: productId, unitCost: data.unitCost, quantity: data.quantity }]
      }
    ];

    setIsLoading(true);
    createMovement(dataToSed)
      .then((response: boolean) => {
        if (response === true) {
          showNotistack({ message: 'La entrada se guardó correctamente' });
          getAllProducts();
          handleCloseModal();
        } else {
          showNotistack({ message: 'Ocurrió un error' });
        }
      })
      .catch((err: any) => {
        console.log(err.reponse?.data);
        showNotistack({ message: 'Ocurrió un error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const imageProduct = (url: string, key: string) => {
    return <img src={url} key={key} alt="productImage" height="90px" width="90px" className={classes.containerImage} />;
  };

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Grid container direction="row" spacing={2} justify="center">
        <Grid item xs={12} sm={12} md={12}>
          <Grid container justify="space-around">
            <Grid item xs={4}>
              {isLoading ? (
                <Grid container justify="center" style={{ marginTop: 15 }}>
                  <Skeleton variant="rect" width="90px" height="60px" />
                </Grid>
              ) : (
                <Fragment>
                  {galeryImagesProduct.map((image: any, index: number) => (
                    <Fragment key={`${image.url}${index}`}>
                      {image.main ? (
                        <Fragment>
                          {image.url ? imageProduct(image.url, image.url) : imageProduct(productImage, image.url)}
                        </Fragment>
                      ) : null}
                    </Fragment>
                  ))}
                </Fragment>
              )}
            </Grid>
            <Grid item xs={8}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                label="Producto"
                value={productDetail.name}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <Grid container justify="space-between" direction="row">
            <Grid item xs={5}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="sku"
                label="SKU"
                value={productDetail.sku}
                autoComplete="sku"
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="purchaseOrder"
                label="Número de orden"
                autoFocus
                inputRef={register<HTMLInputElement>()}
                //disabled={isLoading}
                error={errors.purchaseOrder ? true : false}
                helperText={errors.purchaseOrder && errors.purchaseOrder.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <Grid container justify="space-between" direction="row">
            <Grid item xs={5}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="quantity"
                label="Cantidad"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido',
                  pattern: {
                    value: /^[0-9\b]+$/,
                    message: 'Cantidad mínima invalida'
                  }
                })}
                error={errors.quantity ? true : false}
                helperText={errors.quantity && errors.quantity.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={5}>
              <NumberFormat
                required
                thousandSeparator={'.'}
                id="unitCost"
                name="unitCost"
                margin="normal"
                fullWidth
                type="text"
                customInput={TextField}
                decimalSeparator=","
                variant="outlined"
                label="Costo unitario"
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido'
                })}
                allowNegative={false}
                InputLabelProps={{ shrink: true }}
                error={errors.unitCost ? true : false}
                disabled={isLoading}
                helperText={errors.unitCost && errors.unitCost.message}
                prefix="$"
              />
            </Grid>
          </Grid>
          <Grid container justify="space-between" direction="row">
            <Grid item xs={5}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="remission"
                label="Remisión"
                inputRef={register<HTMLInputElement>()}
                disabled={isLoading}
                error={errors.remission ? true : false}
                helperText={errors.remission && errors.remission.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="invoice"
                label="Factura"
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido'
                })}
                disabled={isLoading}
                error={errors.invoice ? true : false}
                helperText={errors.invoice && errors.invoice.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <TextField
            required
            variant="outlined"
            margin="normal"
            fullWidth
            name="observations"
            label="Observaciones"
            inputRef={register<HTMLInputElement>()}
            multiline
            rows={3}
            disabled={isLoading}
            error={errors.observations ? true : false}
            helperText={errors.observations && errors.observations.message}
            InputLabelProps={{ shrink: true }}
          />
          <Grid container justify="center">
            <Button type="submit" variant="contained" color="primary" disabled={isLoading} style={{ marginTop: 10 }}>
              {isLoading ? <CircularProgress size={24} /> : ''} Guardar
            </Button>
            <Button
              variant="contained"
              color="default"
              disabled={isLoading}
              style={{ marginTop: 10, marginLeft: 20 }}
              onClick={handleCloseModal}
            >
              {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
